/**
 * ThemeProvider Component
 * Wraps FluentProvider and automatically detects Office theme (light/dark mode)
 */

import React, { useEffect, useState } from "react";

import { FluentProvider } from "@fluentui/react-components";

import {
  benchlyLightTheme,
  benchlyDarkTheme,
  detectOfficeDarkMode,
} from "../../theme/benchly-theme";

interface ThemeProviderProps {
  children: React.ReactNode;
}

export const ThemeProvider: React.FC<ThemeProviderProps> = ({ children }) => {
  const [isDarkMode, setIsDarkMode] = useState<boolean>(false);

  // Detect Office theme on mount
  useEffect(() => {
    const detectTheme = () => {
      const isOfficeDark = detectOfficeDarkMode();
      console.log(`[ThemeProvider] Office dark mode detected: ${isOfficeDark}`);
      setIsDarkMode(isOfficeDark);
    };

    // Small delay to ensure Office.js is fully initialized
    const timer = setTimeout(detectTheme, 100);
    return () => clearTimeout(timer);
  }, []);

  const currentTheme = isDarkMode ? benchlyDarkTheme : benchlyLightTheme;

  return <FluentProvider theme={currentTheme}>{children}</FluentProvider>;
};

export default ThemeProvider;
